const allergenImages = {
  Gluten: '/assets/images/product/Wheat.svg',
  Crustacee: '/assets/images/product/Crab.svg',
  Ouă: '/assets/images/product/Eggs.svg',
  Peste: '/assets/images/product/Fish.svg',
  Arahide: '/assets/images/product/Peanuts.svg',
  Soia: '/assets/images/product/Soya.svg',
  Lapte: '/assets/images/product/milk.svg',
  Țelină: '/assets/images/product/Celery.svg',
  Muștar: '/assets/images/product/Mustard.svg',
  Susan: '/assets/images/product/Sesame.svg',
  Sulfiti: '/assets/images/product/Sulphites.svg',
  Lupin: '/assets/images/product/Lupine.svg',
  Moluște: '/assets/images/product/Crab.svg',
  Beef: '/assets/images/product/Beef.svg',
  Chicken: '/assets/images/product/Chicken.svg',
  Frosted: '/assets/images/product/Frosted.svg',
  Mushroom: '/assets/images/product/Mushroom.svg',
  Vitamin: '/assets/images/product/Vitamin.svg',
  Spicy: '/assets/images/product/Spicy.svg',
  Banana: '/assets/images/product/Banana.svg',
  Pork: '/assets/images/product/Pork.svg',
}

export default allergenImages
